import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button } from "@material-ui/core";
import ACCESS from "../../../ACCESS.js";

class Refacturaciones extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: "refacturacion/filter",
        deleteUrl: "",
        deleteField: "id",
        modUrl: "/Ventas/Refacturar",
      },
      TableOp.Table(
        "Refacturaciones",
        [
          { label: "Folio", id: "id" },
          { label: "Factura Anterior", id: "folio_factura_anterior" },
          { label: "Factura Nueva", id: "folio_factura_nueva" },
          { label: "Timbrado", id: "timbrado" },
          { label: "Usuario", id: "usuario" },
          { label: "Fecha de Refacturacion", id: "fecha_refacturacion" },
        ],
        [
          { id: "edit", icon: "edit", access: [ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_CREADAS_POR_EL_USUARIO, ACCESS.VENTAS_REFACTURACION.VER_TODAS_FACTURAS, ACCESS.VENTAS_REFACTURACION.VER_FACTURAS_SUCURSAL_DEL_USUARIO] },
        ]
      )
    );
    this.table();
  }

  render() {
    const { hasAccess } = this.context;
    return (
      <div>
        <div style={{ display: 'flex', padding: '0px 10px', justifyContent: 'space-between', alignItems: 'center' }} >
          {
            hasAccess(ACCESS.VENTAS_REFACTURACION.CREAR_REFACTURACION) &&
            <Button color="primary" variant={"contained"} onClick={() => { this.props.history.push(`/Ventas/Refacturar`) }} >
              Nueva Refacturacion
            </Button>
          }
        </div>
        <this.TableRender />
      </div>
    );
  }
}

export default withRouter(Refacturaciones);
